import { Select, styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreDialogTitle, CoreDialogActions } from '@youscience/core';

import ActionButton from '@components/ActionButton';

export const sxStyles = {
  dialog: {
    maxHeight: '100%',

    '.MuiPaper-root': {
      borderRadius: '12px',
      position: 'relative',
      paddingBottom: '94px',
      width: '100%',
    },
  },
  contentWrap: (theme: Theme) => ({
    padding: '3rem',
    borderTop: `1px solid ${theme.palette.grey['300']}`,
  }),
  contentInner: {
    maxWidth: '796px',
    width: '100%',
    margin: '4rem auto 0',
  },
  description: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  autocomplete: {
    margin: '1.5rem 0',
  },
  accordingMajorsTitle: (theme: Theme) => ({
    paddingBottom: '1rem',
    marginBottom: '1rem',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  majorsWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& > p:first-of-type': {
      marginTop: '1.5rem',
    },
  },
  ipedsBg: (theme: Theme) => ({
    '& > div:first-of-type': {
      backgroundColor: theme.palette.common.white,
    },
  }),
};

export const StyledDialogTitle = styled(CoreDialogTitle)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1.5rem',
  fontSize: '1.125rem',
}));

export const StyledSortByWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  minWidth: '325px',

  '& > h5:first-of-type': {
    marginLeft: '0.5rem',
    marginRight: '0.25rem',
  },
}));

export const StyledSortSelect = styled(Select)(({ theme }) => ({
  '.MuiOutlinedInput-input': {
    padding: '0.375rem',
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: 0,
  },

  '& > svg:first-of-type': {
    color: theme.palette.common.black,
  },
}));

export const StyledSearchResults = styled('div')(({ theme }) => ({
  margin: '1rem 0 1.5rem',
  padding: '2.5rem 0',
  borderTop: `1px solid ${theme.palette.grey['300']}`,
  borderBottom: `1px solid ${theme.palette.grey['300']}`,
}));

export const StyledFooter = styled(CoreDialogActions)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  minHeight: '94px',
  borderTop: `1px solid ${theme.palette.grey['300']}`,
}));

export const StyledCancelBtn = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '82px',
  height: '46px',
  padding: '0.5rem',
  borderRadius: '50px',
  color: coreThemeColors.secondary.main,
  transition: 'background-color 0.5s',

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: coreThemeColors.secondary.outlinedHoverBackground,
  },
}));

export const StyledSaveBtn = styled(ActionButton)(() => ({
  width: '82px',
  height: '46px',
  backgroundColor: coreThemeColors.secondary.main,
  borderRadius: '50px',
  transition: 'background-color 0.5s',

  '&:hover': {
    backgroundColor: coreThemeColors.secondary.dark,
  },
}));
